import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Bookings = () => {
  const [bookings, setBookings] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await axios.get(
          '/api/bookings/',
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setBookings(response.data);
      } catch (err) {
        console.error('Ошибка:', err);
        setError('Не удалось загрузить бронирования');
      }
    };

    fetchBookings();
  }, []);

  return (
    <div>
      <h1>Ваши бронирования</h1>
      {error && <div className="error-message">{error}</div>}
      {bookings.length === 0 ? (
        <p>У вас нет активных бронирований.</p>
      ) : (
        <ul>
          {bookings.map(booking => (
            <li key={booking.id}>
              <p>Автомобиль: {booking.car?.brand} {booking.car?.model}</p> {/* Используйте ?. для защиты */}
              <p>Дата начала: {booking.start_date}</p>
              <p>Дата окончания: {booking.end_date}</p>
              <p>Стоимость: {booking.total_price} руб.</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Bookings;